export const isExternalLink = (link) => /^(?=https?:\/\/|www\.)/.test(link)
